// extracted by mini-css-extract-plugin
module.exports = {"header":"headerDesktop_header__qnJLd"};